import styled from '@emotion/styled';
import { CommonBorder } from 'ui/theme/Color';

export const MapLayout = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  .statusBadge {
    position: absolute;
    top: 3px;
    right: 8px;
    z-index: 500;
    background: #fff;
    padding: 2px 4px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 12px;
  }
  &.border {
    border: 1px ${CommonBorder.Basic} solid;
  }
  &.height_1 {
    height: calc(100vh - 420px);
    min-height: 300px;
  }
  &.height_2 {
    height: calc(100vh - 510px);
    min-height: 350px;
  }
  &.statusPo {
    .statusBadge {
      bottom: -4px;
      right: 0;
    }
  }
  &.noPadding {
    flex-grow: 1;
    position: absolute;
    margin: -12px 0 0 -16px;
  }
`;
